import { render } from "./student-card-actions.vue?vue&type=template&id=2a323cbc&scoped=true&ts=true"
import script from "./student-card-actions.ts?vue&type=script&lang=ts&external"
export * from "./student-card-actions.ts?vue&type=script&lang=ts&external"

import "./student-card-actions.scss?vue&type=style&index=0&id=2a323cbc&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a323cbc"]])

export default __exports__